import { QueryClient } from '@tanstack/react-query';

/**
 * Stale-time policy (ADR-009 §1):
 * - dictionary (tags, tag-categories, vocal-languages): 5 min
 * - lists (tracks, presets, accounts):                 30 s   <- default
 * - single entity (`tracks/:id`):                      10 s
 * - facets:                                            10 s
 * - sidebar live counters:                              0 s   (always refetch)
 *
 * Per-query overrides should be passed via `useQuery({ staleTime: STALE_TIME.dictionary })`.
 * The default below applies to lists; other categories pass their own value through the
 * STALE_TIME map, which is the single source of truth.
 */
export const STALE_TIME = {
  dictionary: 5 * 60 * 1000,
  list: 30 * 1000,
  single: 10 * 1000,
  facets: 10 * 1000,
  liveCounter: 0,
} as const;

export const GC_TIME = 5 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      gcTime: GC_TIME,
      staleTime: STALE_TIME.list,
      refetchOnWindowFocus: false,
    },
  },
});
